import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";

const PlaceBid = ({ isDisabled }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const redirectHome = () => {
    history.push(PATHS.LOGIN_PAGE);
  };

  return (
    <div className="page-block-form">
      <Button
        type="primary"
        className="page-block-form-button large"
        onClick={redirectHome}
        disabled={isDisabled}
      >
        {t("product.place_a_bid")}
      </Button>
    </div>
  );
};

export default PlaceBid;
